import React, {Component} from 'react';
import * as api from '../../api';
import 'semantic-ui-css/semantic.min.css';
import FilterableDatatable from "../../components/table/filterable-data-table";
import SiteTableContactHeader from "./site-table-contact-header";
import SiteTableContactRow from "./site-table-contact-row";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import ReactGA from 'react-ga';

export default class SiteContactsTab extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dataProvider: new ApiDataProvider(api.getSitesContacts, [this.props.customerId,this.props.siteKey]),
        };
    }

    render() {
        return (
            <FilterableDatatable dataProvider={this.state.dataProvider} headerComponent={SiteTableContactHeader} rowComponent={SiteTableContactRow} />
        );
    }

    componentDidMount = () => {
        this.fetchData();
        ReactGA.pageview('site contact tab');
    };

    fetchData = () => {
      
    };
}